<template>
  <div class="navbar">
    <hamburger
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />

    <breadcrumb class="breadcrumb-container" />

    <el-button
      v-show="isShowSop"
      round
      size="small"
      style="margin-right: 10px"
      type="primary"
      @click="downloadSop"
    >{{ $t('navbar.viewSOP') }}
    </el-button>
    <sopWin ref="sopRef" />

    <div class="right-menu">
      <!-- 切换语言 -->
      <div aria-label="切换语言" class="todo navbar-action navbar-action--lang">
        <span class="navbar-action__halo">
          <lang-select />
        </span>
      </div>
      <!--  消息提示  -->
      <el-popover
        ref="popoverRef123"
        :width="350"
        placement="bottom"
        popper-class="navbar-popover navbar-popover--message"
        trigger="click"
      >
        <template #reference>
          <div class="messageTip navbar-action" @click.stop="getSystemMessage">
            <el-badge
              v-if="getmessageNumber > 0"
              :max="99"
              :value="getmessageNumber"
              class="item navbar-action__badge"
            >
              <i class="el-icon-bell navbar-action__icon" />
            </el-badge>
            <i v-else class="el-icon-bell navbar-action__icon" />
          </div>
        </template>
        <el-tabs v-model="activeName">
          <el-tab-pane :label="`${$t('GlobalSetObj.info')}(${messageList.length})`" name="second">
            <div v-if="messageList.length" class="message-list" style="height: 300px">
              <div
                v-for="item in messageList"
                :key="item.id"
                class="message-item"
                @click="handleMessageInfo(item)"
              >
                <el-badge v-if="item.isRead === 0" :value="1" class="item">
                  <img alt="" class="message-icon" src="@/assets/images/msg02.png">
                </el-badge>
                <img
                  v-else alt="" class="message-icon"
                  src="@/assets/images/msg02.png"
                >
                <div class="message-content">
                  <el-tooltip
                    :content="item.title"
                    class="item"
                    effect="dark"
                    placement="top-start"
                  >
                    <span class="message-title sle">{{ item.title }}</span>
                  </el-tooltip>
                  <span class="message-date">{{ item.createTime }}</span>
                </div>
              </div>
            </div>
            <div v-else class="message-empty">
              <img alt="notData" src="@/assets/images/notData.png">
              <div>暂无消息</div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-popover>
      <el-popover
        placement="bottom"
        popper-class="navbar-popover navbar-popover--todo"
        trigger="click"
        width="600"
      >
        <msg-item
          :key="newKey" :all-total="allTotal" :grid-data="gridData"
          @getMsg="getMsg"
        />
        <div slot="reference" aria-label="待办消息" class="numberMsg navbar-action">
          <span class="navbar-action__halo">
            <el-badge
              v-if="msgNum" :max="99" :value="msgNum"
              class="item navbar-action__badge"
            >
              <i class="el-icon-tickets navbar-action__icon" />
            </el-badge>
            <i v-else class="el-icon-tickets navbar-action__icon" />
          </span>
        </div>
      </el-popover>
      <!--  搜索菜单栏  -->
      <div class="messageTip navbar-action" @click="handleSearchMenm">
        <el-tooltip
          :content="$t('customerManagements.searchMenu')"
          class="item"
          effect="dark"
          placement="top"
        >
          <span class="navbar-action__halo">
            <i class="el-icon-search navbar-action__icon" />
          </span>
        </el-tooltip>
      </div>
      <el-dropdown class="avatar-container user-menu">
        <div class="avatar-wrapper user-pill">
          <div class="imgs">
            <el-image
              :src="avatar + '?imageView2/1/w/80/h/80'"
              class="user-avatar-image"
              fit="cover"
            />
          </div>
          <div class="imgs_box">
            <p>{{ orgName }}</p>
            <p>{{ realName }}</p>
          </div>
          <i class="el-icon-arrow-down user-pill__arrow" />
        </div>

        <!-- 右上角下拉菜单 -->
        <el-dropdown-menu slot="dropdown" class="user-dropdown navbar-user-dropdown">
          <el-dropdown-item @click.native="goPersonalCenter">
            <span style="display: block">{{ $t('login.personalCenter') }}</span>
          </el-dropdown-item>
          <el-dropdown-item divided @click.native="goChangePwd">
            <span style="display: block">{{ $t('login.changePwd') }}</span>
          </el-dropdown-item>
          <el-dropdown-item divided @click.native="logout">
            <span style="display: block">{{ $t('login.lginOut') }}</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <searchMenu ref="searchMenuRef" />
    <systemMessagePopUp ref="systemMessagePopUpRef" @readMessage="onReadMessage" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Breadcrumb from '@/components/Breadcrumb';
import store from '@/store';
import Hamburger from '@/components/Hamburger';
import { closeBag } from '@/utils/closeBag';
import { MessageBox } from 'element-ui';
import { getOrganizationTree } from '@/api/organization';
import { getNoReadMsg, queryCurrentUserMessage } from '@/api/messageCenter';
import { getLogout } from '@/api/user';
import dayjs from 'dayjs';
import { getPermissionStructure } from '@/api/permission';
import { findByCode } from '@/utils/menuHelper';

import { sopMenuPage } from '@/api/sop';

export default {
  components: {
    Breadcrumb,
    Hamburger,
    // todos,
    msgItem: () => import('@/components/msgContainer'),
    'lang-select': () => import('@/components/LangSelect/index.vue'),
    searchMenu: () => import('@/layout/components/searchMenu.vue'),
    sopWin: () => import('./sopWin.vue'),
    systemMessagePopUp: () => import('@/components/systemMessagePopUp/index.vue')
  },
  data() {
    return {
      isShowSop: false,
      menuData: [],
      realName: store.getters.realName,
      orgName: '', // 职位名称
      msgNum: 0,
      visible: false,
      showTheme: false,
      newKey: new Date().getTime(),
      isLockScreen: '',
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {}
      },
      gridData: [],
      allTotal: 0,
      activeName: 'second',
      messageList: [],
      intervalTime: null, // 系统消息
      intervalTime2: null
    };
  },
  computed: {
    ...mapGetters(['sidebar', 'avatar', 'getmessageNumber'])
  },
  watch: {
    // 路由切换时重新判断该路由是否配置了SOP
    $route() {
      if (this.menuData.length) {
        this.showSopBtnFn();
      }
    }
  },

  created() {
    this.isLockScreen = localStorage.getItem('UnlockScreen');
    this.getOrg();
    this.getMenu();
  },
  mounted() {
    this.getSysCpfMessage();
    // 初始化轮询（不再直接启动定时器，改为主动校验）
    // 初始化轮询（不再直接启动定时器，改为主动校验）
    this.initRoundRobin();
    this.initRoundRobin2();
    // this.roundRobin();
    // this.roundRobin2();
    this.bus.$on('upDateMsg', () => {
      this.getUnreadMsg();
    });
    this.getSystemMessage();
  },
  beforeDestroy() {
    clearInterval(this.intervalTime);
    this.intervalTime = null;
    clearInterval(this.intervalTime2);
    this.intervalTime2 = null;
  },
  methods: {
    // 切换路由后先查看该路由有没有配置sop，有就显示该按钮
    showSopBtnFn() {
      const matched = this.$route.matched.filter((item) => item.meta && item.meta.title);
      const routePath = matched[matched.length - 1];
      if (!routePath || !routePath.meta || !routePath.meta.roles) {
        this.isShowSop = false;
        return;
      }
      const code = routePath.meta.roles[routePath.meta.roles.length - 1];
      const filVal = findByCode(this.menuData, code);
      if (!filVal || !filVal.id) {
        this.isShowSop = false;
        return;
      }
      sopMenuPage(filVal.id)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.isShowSop = true;
          } else {
            this.isShowSop = false;
          }
        })
        .catch(() => {
          this.isShowSop = false;
        });
    },
    getMenu() {
      getPermissionStructure().then((res) => {
        if (res.code === 200) {
          this.menuData = res.data.permissionStructure;
          // 菜单数据加载完成后，判断当前路由是否配置了SOP
          this.showSopBtnFn();
        }
      });
    },
    downloadSop() {
      // 获取路由数据（包含权限字段）
      const matched = this.$route.matched.filter((item) => item.meta && item.meta.title);
      const routePath = matched[matched.length - 1];
      const code = routePath.meta.roles[routePath.meta.roles.length - 1];
      // 匹配接口返回的带id的菜单对象
      const filVal = findByCode(this.menuData, code);
      this.$refs.sopRef.openWin(filVal.id);
    },
    // 获取用户的cpf（带3分钟请求间隔控制）
    getSysCpfMessage() {
      try {
        // 1. 读取本地存储的上次请求时间
        const lastRequestTime = localStorage.getItem('getSysMessageDate');
        // 2. 初始化是否需要请求接口的标识
        let needRequest = false;
        if (!lastRequestTime) {
          // 无上次请求时间 → 首次请求，需要调用接口
          needRequest = true;
        } else {
          // 有上次时间 → 计算与当前时间的分钟差（使用dayjs精准计算）
          const lastTime = dayjs(lastRequestTime);
          const currentTime = dayjs();
          // 校验时间是否解析有效 + 计算间隔分钟数  10 分钟刷新请求
          if (!lastTime.isValid() || currentTime.diff(lastTime, 'minute') >= 10) {
            needRequest = true; // 时间解析失败/间隔≥3分钟 → 重新请求
          }
          // 间隔<3分钟 → needRequest为false，跳过接口请求
        }
        // 3. 满足条件才调用接口，否则直接返回（不弹框）
        if (needRequest) {
          console.log('needRequest');
          this.getUnreadMsg();
        }
      } catch (error) {
        // 异常捕获：接口请求失败时不阻塞页面，打印错误便于排查
        console.log('获取信息失败：', error);
      }
    },
    // 点击搜索菜单栏
    handleSearchMenm() {
      this.$refs.searchMenuRef.openSearchMenu();
    },
    // ========== 核心修改1：初始化轮询（替代原roundRobin） ==========
    initRoundRobin() {
      // 先校验是否满足30分钟间隔，满足则立即执行一次
      this.checkAndExecHandleMessage();
      // 启动定时器（每分钟检查一次，而非直接30分钟后执行）
      this.intervalTime = window.setInterval(() => {
        this.checkAndExecHandleMessage();
      }, 5 * 60 * 1000); // 每分钟检查一次，避免定时器漂移
    },
    // 校验并执行handleMessage（核心：本地存储控制30分钟间隔）
    checkAndExecHandleMessage() {
      const LAST_REQUEST_KEY = 'last_handle_message_time'; // 本地存储key
      const lastTime = localStorage.getItem(LAST_REQUEST_KEY);
      const now = Date.now();
      const THIRTY_MINUTES = 60 * 60 * 1000; // 60分钟毫秒数

      // 无上次时间 或 间隔≥30分钟 → 执行请求并更新时间
      if (!lastTime || now - Number(lastTime) >= THIRTY_MINUTES) {
        localStorage.setItem(LAST_REQUEST_KEY, now.toString());
      }
      // 不满足则跳过，等待下一次检查
    },
    //  /message/getCurrentUserMessage
    // ========== 核心修改2：初始化轮询2（替代原roundRobin2） ==========
    initRoundRobin2() {
      // 先校验是否满足30分钟间隔，满足则立即执行一次
      this.checkAndExecGetUnreadMsg();
      // 启动定时器（每5分钟检查一次）
      this.intervalTime2 = window.setInterval(() => {
        this.checkAndExecGetUnreadMsg();
      }, 5 * 60 * 1000);
    },
    // 校验并执行getUnreadMsg（核心：本地存储控制30分钟间隔）
    checkAndExecGetUnreadMsg() {
      const LAST_UNREAD_KEY = 'last_get_unread_msg_time'; // 本地存储key
      const lastTime = localStorage.getItem(LAST_UNREAD_KEY);
      const now = Date.now();
      const THIRTY_MINUTES = 60 * 60 * 1000;

      // 无上次时间 或 间隔≥30分钟 → 执行请求并更新时间
      if (!lastTime || now - Number(lastTime) >= THIRTY_MINUTES) {
        this.getUnreadMsg();
        localStorage.setItem(LAST_UNREAD_KEY, now.toString());
      }
      // 不满足则跳过
    },
    // 查询系统消息
    async getSystemMessage() {
      const data = {
        receiveId: store.getters.userId,
        systemType: 1,
        clientType: 1
      };
      const res = await queryCurrentUserMessage(data);
      if (res.code === 200) {
        if (res.data && res.data.length > 0) {
          this.messageList = res.data;
          // 计算未读消息数量（isRead === 0 表示未读），写入全局状态
          const unreadCount = res.data.filter((item) => item.isRead === 0).length;
          this.$store.commit('user/set_getmessageNumber', unreadCount);
        }
      }
    },
    // 点击系统消息 触发弹框  == > 设置已读
    async handleMessageInfo(item) {
      this.$refs.systemMessagePopUpRef.openDialog(item);
    },
    // 消息已读后（数量已在 systemMessagePopUp.setClose 中全局同步 -1）
    onReadMessage() {
      // 仅刷新消息列表，未读数量由全局状态统一管理，避免重复扣减
      this.getSystemMessage();
    },
    getUnreadMsg() {
      getNoReadMsg(this.queryForm)
        .then((res) => {
          // 【新增】主动调用时更新本地存储时间戳
          localStorage.setItem('last_get_unread_msg_time', Date.now().toString());
          const { code, data } = res;
          if (code !== 200) {
            return;
          }
          const resultData = data.records.map((item) => {
            if (item.msgType === 10) {
              item.msgData = JSON.parse(item.msgData);
            }
            return item;
          });
          this.gridData = resultData;
          this.allTotal = data.total;
          this.newKey = new Date().getTime();
          // if (this.gridData.length > 0) {
          //   this.$notify({
          //     title: '通知',
          //     dangerouslyUseHTMLString: true,
          //     message:
          //       '您有 <span style="color: red;font-size: 16px;font-weight: bold;">' +
          //       this.allTotal +
          //       '</span> 条消息需处理',
          //     position: 'top-right',
          //     type: 'warning',
          //     offset: 60
          //   });
          // }
          this.msgNum = this.allTotal;
          this.visible = false;
          // if (!type) {
          //   this.searchUnread();
          // }
          // this.getMsg({ num: this.allTotal, show: false });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getOrg() {
      const { orgId } = this.$store.state.user;
      getOrganizationTree()
        .then((res) => {
          if (res.status === 'OK') {
            res.data.forEach((arr) => {
              if (arr.id === orgId) {
                this.orgName = arr.name;
              }
            });
          }
        })
        .catch({});
    },
    // 取消自动锁屏
    UnlockScreen(type) {
      if (type === 1) {
        localStorage.setItem('UnlockScreen', 'true');
        this.isLockScreen = 'true';
        return;
      }
      localStorage.setItem('UnlockScreen', 'false');
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    clearSession() {
      getLogout()
        .then((res) => {
          sessionStorage.clear();
          // localStorage.clear();  不能全部清空,需要记录电子秤品牌
          // 上门交件——start
          localStorage.removeItem('scanTableData');
          localStorage.removeItem('collectOrderList');
          localStorage.removeItem('customerId');
          localStorage.removeItem('customerName');
          localStorage.removeItem('merchantCode');
          localStorage.removeItem('merchantName');
          // 上门交件——end

          // 报表——start
          localStorage.removeItem('MROddHQueryForm');
          localStorage.removeItem('MROddMXQueryForm');
          localStorage.removeItem('MRTimeMXQueryForm');
          localStorage.removeItem('MRTimeHZQueryForm');
          localStorage.removeItem('TFOddHZQueryForm');
          localStorage.removeItem('TFOddMXQueryForm');
          localStorage.removeItem('TFTimeHZQueryForm');
          localStorage.removeItem('TFTimeMXQueryForm');
          localStorage.removeItem('RDHZQueryForm');
          localStorage.removeItem('carMQueryForm'); // 装车卸车数据监控
          localStorage.removeItem('collectTimeReportForm'); // 揽收时效报表
          localStorage.removeItem('kpiQueryForm');
          localStorage.removeItem('ctcQueryForm');
          // 报表——end

          // 查询条件——start
          localStorage.removeItem('lanshouOrdersQueryForm'); // 揽收订单
          localStorage.removeItem('sroQueryForm'); // 备货揽收订单
          localStorage.removeItem('ptpQueryForm'); // 轨迹推送
          localStorage.removeItem('rdpQueryForm'); // 揽收数据处理
          localStorage.removeItem('scQueryForm'); // 上门交件
          localStorage.removeItem('sftqQueryForm'); // 签收查询
          localStorage.removeItem('smsQueryForm'); // 短信管理
          localStorage.removeItem('mmQueryForm'); // 商户管理
          localStorage.removeItem('vmQueryForm'); // 车辆管理
          localStorage.removeItem('zzQueryForm'); // 邮编管理
          localStorage.removeItem('pdQueryForm'); // 揽收异常件
          localStorage.removeItem('billQueryForm'); // 账单推送
          localStorage.removeItem('qmQueryForm'); // 报价维护
          localStorage.removeItem('maQueryForm'); // 寄件区域
          localStorage.removeItem('cnQueryForm'); // 车签号
          localStorage.removeItem('umQueryForm'); // 员工管理
          localStorage.removeItem('ciQueryForm'); // 揽收商家查询
          localStorage.removeItem('packetQueryForm'); // 稽包查询
          localStorage.removeItem('rivqForm'); // 揽收信息确认查询
          localStorage.removeItem('tcvcqForm'); // 转运中心车辆确认查询
          // 查询条件——end

          // 清除缓存
          localStorage.removeItem('singleScanTableData');
          localStorage.removeItem('totalTableData');
          localStorage.removeItem('signScanList');

          localStorage.removeItem('vue_admin_template_token-management');
          localStorage.removeItem('orgIdAndName');
          localStorage.removeItem('userIdAndName');
          localStorage.removeItem('positionList');
          localStorage.removeItem('organizationTree');
          // 控制系统弹框的
          localStorage.removeItem('getSysMessageDate');
          localStorage.removeItem('isCPFValidityFirstDate');
          localStorage.removeItem('last_get_unread_msg_time');
          localStorage.removeItem('last_handle_message_time');
          // 等待 Vuex 中的登录态和权限态清理完成后再跳转登录页
          return this.$store.dispatch('user/logout');
        })
        .then(() => {
          this.$router.push(`/login?redirect=${this.$route.fullPath}`);
        })
        .catch((err) => {
          console.error(err);
          // 即使退出接口失败，也强制清理前端登录态，避免页面仍保留旧权限
          this.$store.dispatch('user/logout').finally(() => {
            this.$router.push(`/login?redirect=${this.$route.fullPath}`);
          });
        });
    },
    async logout() {
      const listTrackings = JSON.parse(localStorage.getItem('listTrackings'));
      if (listTrackings && listTrackings.length) {
        MessageBox.confirm(this.$t('navbar.alertLogoutMessage'), {
          confirmButtonText: this.$t('GlobalSetObj.yes'),
          cancelButtonText: this.$t('GlobalSetObj.No'),
          showClose: true,
          type: 'warning'
        })
          .then(() => {
            console.log(listTrackings);
            closeBag(
              listTrackings,
              this.$store.state.user.id,
              dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss')
            )
              .then(() => {
                localStorage.removeItem('listTrackings');
                localStorage.removeItem('tableBag');
              })
              .finally(() => {
                this.clearSession();
              });
          })
          .catch((err) => {
            console.log(err);
            this.clearSession();
          });
      } else {
        this.clearSession();
      }
    },

    goPersonalCenter() {
      this.$router.push({ name: 'personal-center' });
    },
    goChangePwd() {
      this.$router.push({ name: 'changepwd' });
    },
    // 获取消息数据
    getMsg(val) {
      this.getUnreadMsg();
      // this.msgNum = val.num;
      // this.visible = val.show;
    },

    // 锁屏
    handleLock() {
      try {
        sessionStorage.setItem('isLock', '1');
        sessionStorage.setItem('lastHistory', this.$route.path);
        setTimeout(() => {
          this.$router.replace({ path: '/lock' });
        }, 500);
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.themesHeadTop {
  width: 100%;
  height: 20px;
}

.themesNavTop {
  width: 30px;
  height: 100px;
}

.themesHeadLeft {
  float: left;
  width: calc(100% - 30px);
  height: 20px;
  display: inline-block;
}

.themesNavLeft {
  float: left;
  width: 30px;
  height: 120px;
  display: inline-block;
}

.themesCheckBorder {
  border: 1px solid #43a047;
}

.themesNoCheck {
  border: 1px solid #ccc;
}

.navbar {
  display: flex;
  align-items: center;
  height: 60px;
  overflow: hidden;
  position: relative;
  background: #ffffff;
  border-bottom: 1px solid #e5e6eb;
  box-shadow: none;
  padding: 0 18px 0 12px;
  box-sizing: border-box;

  .hamburger-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    padding: 0 !important;
    cursor: pointer;
    transition: all 0.2s ease;
    -webkit-tap-highlight-color: transparent;
    border: 1px solid #edf0f2;
    border-radius: 12px;
    background: #f7f8fa;
    color: #4e5969;

    &:hover {
      border-color: #d8efe1;
      background: #f2fbf6;
      color: #00a551;
    }

    ::v-deep .hamburger {
      width: 20px;
      height: 20px;
      fill: currentColor;
    }
  }

  .breadcrumb-container {
    flex: 1;
    min-width: 0;
    margin-left: 14px;
  }

  .right-menu {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-left: auto;
    height: 44px;
    padding: 3px 6px;
    border: 1px solid #edf0f2;
    border-radius: 999px;
    background: #f7f8fa;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.72);

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-left: 4px;
      min-width: 0;

      .avatar-wrapper {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        max-width: 214px;
        min-height: 36px;
        padding: 3px 10px 3px 5px;
        border: 0;
        border-radius: 999px;
        background: #ffffff;
        box-shadow: none;
        transition: all 0.2s ease;

        .imgs {
          line-height: 1;
          flex: none;
        }

        p {
          margin: 0;
          padding: 0;
          line-height: 1.2;
        }

        .imgs_box {
          margin-left: 10px;
          color: #4e5969;
          min-width: 0;

          p:nth-child(1) {
            margin-bottom: 4px;
            font-size: 12px;
            color: #86909c;
          }

          p:nth-child(2) {
            font-size: 14px;
            font-weight: 600;
            color: #1d2129;
          }

          p {
            max-width: 150px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        .user-avatar-image {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          border: 2px solid #ffffff;
          outline: 1px solid rgba(0, 165, 81, 0.35);
          background: #f2fbf6;
        }

        .user-pill__arrow {
          margin-left: 10px;
          font-size: 12px;
          color: #86909c;
        }

        &:hover {
          background: #f2fbf6;
          box-shadow: 0 6px 18px rgba(0, 165, 81, 0.1);
        }
      }
    }
  }

  .showTodosStyle {
    float: right;
    margin-top: 5px;
    margin-right: 20px;
  }

  .messageTip {
    cursor: pointer;
  }
}

.numberMsg {
  cursor: pointer;
}

.navbar-action {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  margin-left: 0;
  padding: 0;
  position: relative;
  border: 0;
  border-radius: 12px;
  background: transparent;
  color: #4e5969;
  transition: all 0.2s ease;

  &:hover {
    background: #ffffff;
    color: #00a551;
    box-shadow: 0 6px 18px rgba(0, 165, 81, 0.1);
  }
}

.navbar-action__halo,
.navbar-action__trigger {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: inherit;
}

/* 让 popover 的 reference 包裹层撑满整个按钮区域，扩大点击触发范围 */
.messageTip ::v-deep .el-popover__reference-wrapper,
.messageTip ::v-deep .el-popover__reference {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

/* 由于 .messageTip 现在是 popover 的 reference，承载 38x38 按钮样式 */
.messageTip {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  cursor: pointer;
}

.navbar-action__icon {
  font-size: 17px;
  color: inherit;
}

.navbar-action__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

::v-deep .navbar-action--lang .international,
::v-deep .navbar-action--lang .international > div {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

::v-deep .navbar-action--lang svg {
  width: 21px;
  height: 21px;
}

.message-list {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding-top: 5px;

  .message-item {
    display: flex;
    align-items: center;
    padding: 20px 0;
    border-bottom: 1px solid #e4e7ed;
    cursor: pointer;

    &:last-child {
      border: none;
    }

    .message-icon {
      width: 40px;
      height: 40px;
      //margin: 0 0 0 5px;
    }

    .message-content {
      display: flex;
      flex-direction: column;
      margin-left: 15px;

      .message-title {
        margin-bottom: 5px;
        width: 220px;
      }

      .sle {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .message-date {
        font-size: 12px;
        color: #909399;
      }
    }
  }
}

.msgNumCon {
  position: absolute;
  top: 4px;
  left: 28px;
  line-height: 16px;
  text-align: center;
  padding: 0 6px;
  background: #f56c6c !important;
  color: #fff !important;
  font-size: 12px;
  border-radius: 10px;
}

::v-deep .el-badge__content {
  color: #ffffff !important;
}

.todo {
  cursor: pointer;

  i {
    font-size: 22px;
    color: inherit;
  }
}

::v-deep .el-dropdown-menu.user-dropdown {
  border: 1px solid #e8eeeb;
  border-radius: 14px;
  padding: 8px;
  box-shadow: 0 18px 40px rgba(17, 24, 39, 0.12);
}

::v-deep .el-dropdown-menu.user-dropdown .el-dropdown-menu__item {
  border-radius: 10px;
  color: #4e5969;
  line-height: 38px;

  &:hover {
    background: #e8f7ef;
    color: #00a551;
  }
}

@media (max-width: 1280px) {
  .navbar {
    padding-right: 12px;

    .breadcrumb-container {
      margin-left: 10px;
    }
  }

  .navbar-action {
    width: 34px;
    height: 34px;
  }

  .navbar-action__icon,
  .todo i {
    font-size: 20px;
  }

  .navbar .right-menu .avatar-container .avatar-wrapper {
    max-width: 190px;
    padding-right: 10px;
  }

  .navbar .right-menu .avatar-container .avatar-wrapper .imgs_box p {
    max-width: 104px;
  }
}

@media (max-width: 960px) {
  .navbar {
    padding-right: 10px;
  }

  .navbar-action--lang {
    display: none;
  }

  .navbar .right-menu .avatar-container .avatar-wrapper .imgs_box {
    display: none;
  }

  .navbar .right-menu .avatar-container .avatar-wrapper {
    min-height: 40px;
    padding: 4px 8px;
  }
}
</style>
